import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const CarLocation = ({ carLocation }: SpecProps<"car_location">) => {
  const { i18n } = useLingui();

  if (!carLocation) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.car_location",
    message: "Car location",
    comment: "Field for 'car location' in ad specification",
  });
  return <FieldValuePair field={field} value={carLocation} />;
};
